<script setup lang="ts">
import {
  TooltipPortal,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from "reka-ui"
withDefaults(
  defineProps<{
    text?: string
    size?: "sm" | "lg"
    side?: "top" | "right" | "bottom" | "left"
    disabled?: boolean
  }>(),
  {
    side: "top",
    size: "sm",
    text: undefined,
    disabled: false,
  },
)
const forceOpen = ref(false)
const open = ref(false)
</script>
<template>
  <TooltipProvider :delay-duration="0">
    <TooltipRoot
      v-if="!disabled"
      :open="open || forceOpen"
      @update:open="
        (_open) => {
          // this event is called after hover is done
          // on mobile it's called immediately after click, with `_open=false`.
          // however we want the tooltip to stay open on tap
          if (forceOpen) {
            return
          }
          open = _open
        }
      "
    >
      <TooltipTrigger as-child>
        <div class="w-fit cursor-help" @touchstart="forceOpen = true">
          <slot>
            <div
              class="pointer-events-none flex size-4 items-center justify-center rounded-full bg-zinc-300"
            >
              <SvgoPikaQuestion class="size-3 text-zinc-800" />
            </div>
          </slot>
        </div>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          :side
          :side-offset="5"
          @pointer-down-outside="forceOpen = false"
        >
          <slot name="content">
            {{ text }}
          </slot>
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
    <div v-else>
      <slot />
    </div>
  </TooltipProvider>
</template>
